import React from 'react';

const SwimIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 7.000000)'>
        <path d='M0,14.83 C2.22,13.83 4.44,12.83 6.67,12.83 C8.89,12.83 11.11,14.83 13.33,14.83 C15.56,14.83 17.78,12.83 20,12.83 L20,15.83 C17.78,15.83 15.56,17.83 13.33,17.83 C11.11,17.83 8.89,15.83 6.67,15.83 C4.44,15.83 2.22,16.83 0,17.83 L0,14.83 M6.67,9.83 C5.89,9.83 5.12,9.95 4.35,10.15 L9.27,6.71 L8.23,5.47 C8.09,5.3 8,5.07 8,4.83 C8,4.49 8.17,4.18 8.44,4 L14.16,0 L15.31,1.63 L10.47,5.02 L15.7,11.25 C14.91,11.58 14.12,11.83 13.33,11.83 C11.11,11.83 8.89,9.83 6.67,9.83 M16,3.83 C17.1045695,3.83 18,4.7254305 18,5.83 C18,6.9345695 17.1045695,7.83 16,7.83 C14.8954305,7.83 14,6.9345695 14,5.83 C14,4.7254305 14.8954305,3.83 16,3.83 Z' />
      </g>
    </g>
  </svg>
);

export default SwimIcon;
